import { ClickToComponent } from 'click-to-react-component'
import { ConnectedRouter } from 'connected-react-router'
import MaintenancePage from 'features/Maintenance'
import { createRoot } from 'react-dom/client'
import ReactGA from 'react-ga4'
import { Provider } from 'react-redux'
import initSentry from 'utils/initSentry'

import App from './components/App'
import ErrorBoundary from './components/ReusableComponents/ErrorBoundary/index'
import SocketProvider from './components/ReusableComponents/LoginSocket/index'
import MessagingSocket from './components/ReusableComponents/MessagingSocket'
import { GAID } from './main/globalVariables'
import store, { history } from './main/store'
import * as serviceWorker from './serviceWorker'

ReactGA.initialize(GAID)
initSentry()

const container = document.getElementById('root')
const root = createRoot(container)

const MAINTENANCE_MODE = false

if (MAINTENANCE_MODE) {
  root.render(<MaintenancePage />)
} else {
  root.render(
    <Provider store={store}>
      <ClickToComponent />
      <ConnectedRouter history={history}>
        <SocketProvider>
          <MessagingSocket />
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </SocketProvider>
      </ConnectedRouter>
    </Provider>
  )
}

serviceWorker.register()
